import React, { MouseEventHandler } from "react";

import { useDom } from "../../../../../../../../context/Dom";
import { LocationShape } from "../../../../../../../../types";
import MenuItemContents from "../components/MenuItemContents/MenuItemContents";
import { MenuItemChildren } from "../types";
import useMenuItemStyles from "../utils/useMenuItemStyles";

type MenuLinkProps = {
  children: MenuItemChildren;
  to: string | LocationShape;
  onClick?: MouseEventHandler;
  ariaLabel?: string;
};

export default function ContextMenuLink({
  children,
  to,
  onClick,
  ariaLabel
}: MenuLinkProps) {
  const { Link } = useDom();
  const styles = useMenuItemStyles();

  return (
    <Link
      {...styles}
      className="focus-malibu"
      aria-label={ariaLabel}
      onClick={onClick}
      to={to}
    >
      <MenuItemContents>{children}</MenuItemContents>
    </Link>
  );
}
